import { render, staticRenderFns } from "./IconSvgOdp.vue?vue&type=template&id=4daeeaf7&scoped=true&"
import script from "./IconSvgOdp.vue?vue&type=script&lang=js&"
export * from "./IconSvgOdp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daeeaf7",
  null
  
)

export default component.exports